import { onUnmounted, ref } from 'vue';

const SM_BREAKPOINT = '(max-width: 639px)';

export default function useIsMobile() {
    const isMobile = ref(false);
    const mql = window.matchMedia(SM_BREAKPOINT);

    const update = () => {
        isMobile.value = mql.matches;
    };

    mql.addEventListener('change', update);
    update();

    onUnmounted(() => {
        mql.removeEventListener('change', update);
    });

    return isMobile;
}
